import { useMutation, useQueryClient } from "@tanstack/react-query"

import { api } from "@/lib/api-client"
import { queryKeys } from "@/lib/query-keys"

function deleteTrustedSource(
  sourceId: string,
  type: "personal" | "company" = "personal"
): Promise<void> {
  return api.delete(`/trusted-source/${sourceId}?type=${type}`)
}

export function useDeleteTrustedSource() {
  const queryClient = useQueryClient()

  const deleteTrustedSourceMutation = useMutation({
    mutationKey: queryKeys.deleteTrustedSource,
    mutationFn: ({ sourceId, type }: { sourceId: string; type: "personal" | "company" }) =>
      deleteTrustedSource(sourceId, type),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: queryKeys.trustedSources })
    },
  })

  return deleteTrustedSourceMutation
}
